import styled from '@emotion/styled'

export const PaddedBox = styled.div<{
  padding: number
}>`
  padding: ${(props) => props.padding}px;
`
